const AutoRepair = ({data}) => {
  const main = {
    "@context": "https://schema.org",
    "@type": "AutoRepair",    
    "name": data.name,
    "address": data.address,
    "currenciesAccepted": "ZAR",
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": data.latitude,
      "longitude": data.longitude
    },
    "url": data.website ? data.website : `https://www.mechanicbuddy.co.za/mechanic/${data.url_name}/`
  }

  const structure = {
    ...main,
    ...(data.logo && {
      logo: {
        "@type": "ImageObject",
        url: data.logo + "?w=240",
      }
    }),
    ...(data.images && data.images.length > 0 && {
      "image": data.images.map(i => i.image + "?w=1000")
    }),
    ...(data.total_ratings > 0 && {
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": data.rating,
        "reviewCount": data.total_ratings
      }
    }),
    ...(data.telephone && {"telephone": data.telephone}),
    // ...(data.hours && {
    //   "openingHoursSpecification": data.hours.map(hours => {
    //     return {
    //       "@type": "OpeningHoursSpecification",
    //       "dayOfWeek": hours.day,
    //       "opens": hours.time_open,
    //       "closes": hours.time_close
    //     }
    //   })
    // }),
    ...(data.reviews && data.reviews.length > 0 && {
      "review": data.reviews.map(review => {
        return {
          "@type": "Review",
          "author": review.short_name,
          "datePublished": review.created_at_iso,
          "description": review.comment,
          "name": review.title,
          "reviewRating": {
            "@type": "Rating",
            "bestRating": "5",
            "ratingValue": review.rating,
            "worstRating": "1"
          }
        }
      })
    })
  }

  return (
    <script
      key="localBusiness"
      type='application/ld+json'
      dangerouslySetInnerHTML={{ __html: JSON.stringify(structure)}}
    />
  )
}

export default AutoRepair
